import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex-col-centered selection" }
const _hoisted_2 = { for: "market" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = ["value"]

import { computed, onBeforeMount } from 'vue';
import { marketSelection,  MarketSelection } from '@/services/helpers/Helper';

export default /*#__PURE__*/_defineComponent({
  __name: 'MarketSelector',
  props: {
    enableSE: { type: Boolean },
    shortTitle: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

// const props = defineProps<Partial<{
//     enableSE: boolean;
//     enableAll: boolean;
// }>>();
const markets = computed(()=>{
    const results = Object.entries(MarketSelection);
    if (props.enableSE) return results;
    // if(props.enableAll)   return [['ALL', 'All'], ...results];
    return results.filter(([k,v])=>k!=='SE');
});
onBeforeMount(()=>{
    if (!props.enableSE && marketSelection.value=='SE') marketSelection.value = 'GB';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.shortTitle? "Market:" : "Market Selection:"), 1)
    ]),
    _withDirectives(_createElementVNode("select", {
      id: "market",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(marketSelection) ? (marketSelection).value = $event : null)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emits('change', $event))),
      class: "dropdown"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markets.value, ([market,display]) => {
        return (_openBlock(), _createElementBlock("option", {
          value: market,
          key: market
        }, _toDisplayString(display), 9, _hoisted_4))
      }), 128))
    ], 544), [
      [_vModelSelect, _unref(marketSelection)]
    ])
  ]))
}
}

})